import { Button } from '@mui/material'
import AlphabetGrid from '../AlphabetGrid';
import { useState } from 'react';
import VernamCipherDecryption from './VernamCipherDecryption';
import VernamCipherEncryption from './VernamCipherEncryption';
import CustomButton from '../CustomButton';
// import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';

const VernamCipherSimulation = () => {
  const [selectedPlain, setPlain] = useState("")
  const [selectedCipher, setCipher] = useState("")
  const [plainText, setPlainText] = useState("")
  const [cipherText, setCipherText] = useState("")
  const [key, setKey] = useState("")
  const [clickedSimulate, setClickedSimulate] = useState(false)
  const [isSimulating, setIsSimulating] = useState(false);

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function generateKey(length, key){
    var count = 0;
    var finalKey = "";
    key = key.toUpperCase()
    while(count < length){
      var i = count % (key.length);
      finalKey += key[i]
      count++;
    }
    finalKey = finalKey.toUpperCase();
    console.log("Final Key : ", finalKey);
    return finalKey;
  }

  const encrypt = async (text, k) => {
    const textLength = text.length;
    const finalKey = generateKey(textLength, k)
    let encryptedText = '';
    for (let i = 0; i < textLength; i++) {
      var keyP = (finalKey[i].charCodeAt(0) - 65) % 26;
      // const charCode = (text.charCodeAt(i) - 65) ^ (finalKey.charCodeAt(i) - 65);
      var currentPlain = text[i];
      var currentCipher = String.fromCharCode((currentPlain.charCodeAt(0) + keyP - 65) % 26 + 65);
      encryptedText += currentCipher;
      setPlainText(text.substring(0, i + 1))
      setPlain(currentPlain);
      setCipher(currentCipher);
      setKey(finalKey.substring(0, i + 1));
      setCipherText(encryptedText);
      await sleep(2000);
    }
    

    setIsSimulating(false);
    return encryptedText;
  }

  function handleSubmit(e) {


    // Prevent the browser from reloading the page
    e.preventDefault();
    if (!isSimulating) {
      setIsSimulating(true);
      // Read the form data
      const form = e.target;
      const formData = new FormData(form);

      // You can pass formData as a fetch body directly:
      // fetch('/some-api', { method: form.method, body: formData });

      // Or you can work with it as a plain object:
      const formJson = Object.fromEntries(formData.entries());
      console.log(formJson);

      var res = encrypt(formData.get("plaintext").toUpperCase(), formData.get("key"));
      setClickedSimulate(true)

      console.log(res);
    }

  }

  return (
    <>
      <form method="post" onSubmit={handleSubmit}>
        <label>
          Plain Text (only alphabets, without spaces):
          <input pattern="[a-zA-Z]+" style={{ textTransform: "uppercase" }} required={true} name="plaintext" />
        </label>
        <label>
          Key (only alphabets, without spaces):
          <input pattern="[a-zA-Z]+" style={{ textTransform: "uppercase" }} required={true} name="key" />
        </label>
        <CustomButton type="submit" isSimulating={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</CustomButton>
        {/* <Button variant="contained" type='submit' size='medium' disabled={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</Button> */}
      </form>
      <br />
      <br />
      <br />
      <AlphabetGrid selectedPlain={selectedPlain} selectedCipher={selectedCipher} />
      <div style={{ display: clickedSimulate ? "block" : "none" }} >
        <VernamCipherEncryption plainText={plainText} cipherText={cipherText} finalKey={key} />
      </div>
      <div style={{ display: clickedSimulate ? "block" : "none" }} >
        <hr />
        <VernamCipherDecryption plainText={plainText} cipherText={cipherText} finalKey={key} />
      </div>
    </>
  )
}

export default VernamCipherSimulation